import React from 'react';
import { useTranslation } from 'react-i18next';
import { Titled } from 'react-titled';
import AppLayout from 'components/common/AppLayout';
import ResideoLogo from 'components/logos/resideo-logo.svg?react';
import styled from 'styled-components';
import { Button } from '@resideo/blueprint-react';
import { FIRST_ALERT_LOGIN_CALLBACK_PATH } from 'config';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: ${({ theme }) => theme.space.large};
`;

const StyledResideoLogo = styled(ResideoLogo)`
  padding-top: ${({ theme }) => theme.space.large};

  height: 60px;
`;

const HeaderText = styled.h3`
  font-size: 3rem;
  font-weight: 500;
`;

const DescriptionText = styled.h1`
  margin-top: ${({ theme }) => theme.space.large};
  font-size: 1.5rem;
  font-weight: 500;
`;

const SignInButton = styled(Button)`
  font-size: 1rem;
  height: 45px;
  width: 300px;
`;

const FirstAlertSignIn = () => {
  const { t } = useTranslation();

  const handleSignInButton = () => {
    window.location.href = `${window.location.origin}/${FIRST_ALERT_LOGIN_CALLBACK_PATH}${window.location.search}`;
  };

  return (
    <Titled title={title => `${t('common.signIn')} - ${title}`}>
      <AppLayout
        showHeader={false}
        showLeftNav={false}
        showGreyPanel={false}
        showFooter={false}>
        <Container>
          <StyledResideoLogo data-test-resideo-logo />
          <HeaderText>{t('common.signIn')}</HeaderText>
          <DescriptionText>
            {t('mobileSignInLanding.tapTheButton')}
          </DescriptionText>
          <SignInButton onClick={handleSignInButton} data-test-sign-in-button>
            {t('mobileSignInLanding.completeSignIn')}
          </SignInButton>
        </Container>
      </AppLayout>
    </Titled>
  );
};

export default FirstAlertSignIn;
